<div class="sidebar" [ngClass]="{ expanded: isExpanded }">
  <div class="header">
    <h1 class="title d-flex">
      <img [src]="constants.applicationLogoDarkUrl" class="img-fluid" alt="Company Logo" />
    </h1>
    <div class="toggle" (click)="handleSidebarToggle()">
      <img
        *ngIf="isExpanded; else notExpanded"
        [src]="constants.staticImages.images.sidebarOff"
        alt="Sidebar Off"
        class="sidebar-off-img" />
      <ng-template #notExpanded>
        <img [src]="constants.staticImages.images.sidebarOn" class="sidebar-on-img" />
      </ng-template>
    </div>
  </div>
  <div class="content">
    <ng-container *ngFor="let menu of menuItems">
      <ng-container *ngIf="menu.subMenuOptions?.length">
        <div class="link" [ngClass]="{ 'with-subMenuOptions': menu.subMenuOptions.length }">
          <ng-container [ngTemplateOutlet]="menuTemplate" [ngTemplateOutletContext]="{ menu: menu }"></ng-container>
          <ng-container *ngFor="let child of menu.subMenuOptions">
            <div class="subMenuOptions">
              <div class="link">
                <ng-container
                  [ngTemplateOutlet]="menuTemplate"
                  [ngTemplateOutletContext]="{ menu: child }"></ng-container>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="!menu.subMenuOptions?.length">
        <div class="link">
          <ng-container [ngTemplateOutlet]="menuTemplate" [ngTemplateOutletContext]="{ menu: menu }"></ng-container>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div class="footer"></div>
</div>

<ng-template #menuTemplate let-menu="menu">
  <ng-container *ngIf="!menu.subMenuOptions?.length">
    <div class="content" [routerLink]="menu.routerLink" [routerLinkActive]="'active'" [title]="menu.title">
      <ng-container [ngTemplateOutlet]="menuItemTemplate" [ngTemplateOutletContext]="{ menu: menu }"></ng-container>
    </div>
  </ng-container>
  <ng-container *ngIf="menu.subMenuOptions?.length">
    <div class="content" [ngClass]="{ active: currentActiveParentRoute === menu.moduleKey }" [title]="menu.title">
      <ng-container [ngTemplateOutlet]="menuItemTemplate" [ngTemplateOutletContext]="{ menu: menu }"></ng-container>
    </div>
  </ng-container>
</ng-template>

<ng-template #menuItemTemplate let-menu="menu">
  <div><img [src]="menu.icon" alt="" /></div>
  <div class="title">{{ menu.title }}</div>
</ng-template>
